import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";
import { BankAccountTransactions } from "./BankAccountTransactions";

export class SetTransactionCounterpartManual {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly q_dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(transaction_ids:[string], uuid:string|number, counterpart_account:string, concept: string|null, listFilters?): Promise<any> {
    let args = { 
      transaction_ids: transaction_ids,
      counterpart: counterpart_account,
      concept: concept,
      bank_account_id: uuid
    }
    try {
      //this.frontend.loading_update_counterpart(true)
      await this.dispatcher.dispatch('set.transactions.counterpart.manual', args)
      await new BankAccountTransactions(this.q_dispatcher, this.frontend).run_filter(uuid, listFilters, this.frontend.$refs.bankSimpleFilters.option_selected, this.frontend.limit, this.frontend.offset)
    } catch (error) {
      console.error('Error update transactions counterpart', error)
    }
    //this.frontend.loading_update_counterpart(false)
  }
}